module.exports = __webpack_public_path__ + "static/media/arrow-down.ee69708a.svg";